// require('@babel/polyfill');
import feather from 'feather-icons';
import lightbox from 'lightbox2';
import Plyr from 'plyr';

window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('bootstrap4-datetimepicker');
require('slick-carousel');

lightbox.option({
    'fadeDuration': 200,
    'imageFadeDuration': 200,
    'resizeDuration': 200,
    'wrapAround': true
});

feather.replace();

window.goTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};

$('[data-toggle="tooltip"]').tooltip();
$('#flash-overlay-modal').modal();
$('div.alert').not('.alert-important').delay(3000).fadeOut(350);

const mockupContainer = document.querySelector('#online-jubo');
if (mockupContainer) {
    const juboGroupNavs = mockupContainer.querySelectorAll('#jubo-group-nav > .nav-item > .nav-link');
    if ( juboGroupNavs && juboGroupNavs.length > 0 ) {
        $(juboGroupNavs[0]).tab('show');
        juboGroupNavs[0].setAttribute('aria-selected', true);
        juboGroupNavs[0].classList.add('active');
    }
}


$('#featured-lists').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay:true,
    autoplaySpeed: 2000
});

const currentWeek = document.getElementById('current-week');

$(currentWeek).datetimepicker({
    locale: 'ko',
    dayViewHeaderFormat: 'YYYY년 MM월',
    format: 'YYYY-MM-DD',
    icons: {
        time: "picker picker-time",
        date: "picker picker-date",
        up: "picker picker-up",
        down: "picker picker-down",
        previous: "picker picker-left",
        next: "picker picker-right"
    }
});


currentWeek.addEventListener('change', function(e){
    location.href = `${juboRoute}/${this.value}`;
});

$(currentWeek).on('dp.change', function () {
    location.href = `${juboRoute}/${this.value}`;
});

$(currentWeek).on('dp.show', function(){
    const picker = this.nextElementSibling;
    picker.style.left = '-50px';
});

// 광고 내용 중 전화번호에 링크
const articles = document.querySelectorAll('.content-area[data-content-type="article"]');
if (articles && articles.length > 0 && !navigator.userAgent.match(/iPhone/)) {
    for(const article of articles){
        const searchItems = article.querySelectorAll('li, p');
        if (searchItems && searchItems.length > 0) {
            searchItems.forEach(el=>{
                const rule = /(\d{2,3}-\d{3,4}-\d{4})/g;
                el.innerHTML = el.innerHTML.replace(rule, `<a href="tel:$1">$1</a>`);
                const removeQuote = /^[\"\']{1}(.+)[\"\']{1}$/g;
                el.innerHTML = el.innerHTML.replace(removeQuote, `$1`);
            })
        }
    }
}

const contentAreas = document.querySelectorAll('.content-area');
const fontSizeSwitches = document.getElementById('font-size-switches');

function fontSizeUp() {
    contentAreas.forEach(el=>{
        let currentSize = !el.style.fontSize ? '1em' : el.style.fontSize;
        el.style.fontSize = `${Number(currentSize.replace('em', ''))+0.1}em`;
    })
}
function fontSizeDown() {
    contentAreas.forEach(el=>{
        let currentSize = !el.style.fontSize ? '1em' : el.style.fontSize;
        let fontSize = Number(currentSize.replace('em', ''));
        if ( fontSize <= 1 ) {
            fontSize = 1;
        } else {
            fontSize -= 0.1;
        }

        el.style.fontSize = `${fontSize}em`;
    })
}
function fontSizeDefault() {
    contentAreas.forEach(el=>{
        el.style.fontSize = `1em`;
    })
}

fontSizeSwitches.addEventListener('click', e => {
    let el = e.target;
    while (true) {
        if ( el.nodeName === 'BUTTON') {
            break;
        }
        el = el.parentNode;
    }

    if (el.id === 'font-size-up') {
        fontSizeUp();
    } else if (el.id === 'font-size-down') {
        fontSizeDown();
    } else if (el.id === 'font-size-default') {
        fontSizeDefault();
    }
});

const players = document.querySelectorAll('.player');
if (players && players.length > 0) {
    for(const player of players) {
        const vPlayer = new Plyr(player, {
            muted: false
        });
        $(`#jubo-group-nav a[data-toggle="pill"]`).on('shown.bs.tab', function(e){
            vPlayer.stop();
        });
    }
}
